import {format} from 'date-fns';
import {ru} from 'date-fns/locale';
import {unixTimestampToMilli} from '@utils/dateUtils';

interface Props {
    time: number;
    className?: string;
}

export default function Date(props: Props) {
    return (
        <div className={props.className ?? ''}>
            {format(unixTimestampToMilli(props.time), 'dd MMMM yyyy', {
                locale: ru,
            })}
        </div>
    );
}
